export const ALERGENOS_LIST = [
  { id: 'gluten',       nombre: 'Gluten',       icono: 'G'  },
  { id: 'crustaceos',   nombre: 'Crustáceos',   icono: 'C'  },
  { id: 'huevos',       nombre: 'Huevos',       icono: 'H'  },
  { id: 'pescado',      nombre: 'Pescado',      icono: 'P'  },
  { id: 'cacahuetes',   nombre: 'Cacahuetes',   icono: 'Ca' },
  { id: 'soja',         nombre: 'Soja',         icono: 'So' },
  { id: 'lacteos',      nombre: 'Lácteos',      icono: 'L'  },
  { id: 'frutos_secos', nombre: 'Frutos secos', icono: 'FS' },
  { id: 'apio',         nombre: 'Apio',         icono: 'A'  },
  { id: 'mostaza',      nombre: 'Mostaza',      icono: 'M'  },
  { id: 'sesamo',       nombre: 'Sésamo',       icono: 'Se' },
  { id: 'sulfitos',     nombre: 'Sulfitos',     icono: 'Su' },
  { id: 'moluscos',     nombre: 'Moluscos',     icono: 'Mo' },
  { id: 'altramuces',   nombre: 'Altramuces',   icono: 'Al' },
]
